import { FC, ReactNode } from "react"

import { PgContainer } from "./styles"

export const PageContainer: FC<{ children: ReactNode }> = ({ children }) => {
  return <PgContainer>{children}</PgContainer>
}
